import React from "react"
import styled from "styled-components"
import { Card, Col, Row, Spin } from "antd"
import useBlogs from "../../utils/useBlogs"
import { Link } from "gatsby"
import Moment from "react-moment"

const { Meta } = Card

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6rem;
  h1 {
    font-size: 46px;
    color: #172315;
    font-weight: 700;
    text-align: center;
  }

  .ant-card-meta-title {
    font-size: 22px;
    line-height: 28px;
    color: #172315;
    font-weight: 700;
  }
  .ant-card-meta-description {
    line-height: 28px;
  }
  .card-description {
    padding-top: 4px;
    font-size: 16px;
    color: #172315;
    line-height: 24px;
    font-weight: 500;
  }
  .ant-spin-spinning {
    margin: 8rem;
    overflow: hidden;
    padding: 2rem;
  }

  .circle {
    position: absolute;
    top: 20px;
    right: 20px;
    height: 60px;
    width: 60px;
    background-color: #5a8d52;
    border-radius: 50%;
    display: inline-block;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-date {
    color: #fff;
    text-align: center;
    font-weight: 700;
  }
  .btn-detail {
    border-radius: 3px;
    padding: 8px 30px;
    text-align: center;
    background-color: #5a8d52;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    border: none;
    overflow: hidden;
    cursor: pointer;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.lg)} {
    padding: 2rem;
  }
  ${({ theme: { down, breakpoints } }) => down(breakpoints.sm)} {
    padding: 1rem;
  }
`

const BlogsSection = () => {
  const { blogs, loading } = useBlogs()

  return (
    <StyledSection>
      <h1>Latest Blogs</h1>
      {loading ? (
        <Row justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Row gutter={16}>
          {blogs.slice(0, 3).map(post => (
            <Col sm={24} md={8} key={post.id}>
              <Card
                className="custom-card"
                hoverable
                cover={
                  <img
                    alt="feature-image"
                    src={post.featured_image.size_full}
                  />
                }
              >
                <Meta
                  title={post.title.rendered}
                  description={`${post.author.author_name} . ${post.date} . 3 Comments`}
                />
                <p className="card-description">
                  {post.excerpt.rendered.slice(3, -5)}
                </p>
                <Link to={`/blog-detail?${post.id}`}>
                  <button className="btn-detail">Read more</button>
                </Link>
                <div className="circle">
                  <Moment format="MMM Do" className="card-date">
                    {post.date}
                  </Moment>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </StyledSection>
  )
}

export default BlogsSection
